
define('modules/application/wizard',[
    "app",

    // Libs
    "backbone",

    //Submodules
    "./wizard/steps",

    //Data provider
    "./dataProvider",

    //Calculation classes
    "./calculationClasses/thermoRegulation",
    "./calculationClasses/intrusionDetection",
    "./calculationClasses/audioVideo",
    "./calculationClasses/automation",
    "./calculationClasses/automationSimple",
    "./calculationClasses/energyManagement"
  ],

  function(app, Backbone, Steps, DataProvider, Thermoregulation, IntrusionDetection, AudioVideo, Automation, AutomationSimple, EnergyManagement) {

    // Create a new module
    var Wizard = app.module();

    // Wizard Event Aggregator
    // ----------
    Wizard.EventAggregator = _.extend({}, Backbone.Events); // Event Aggregator for Wizard's elements

    // Wizard Model
    // ----------
    Wizard.Model = Backbone.Model.extend({
      initialize: function() {
        this.unbind("change:systemId", this.setupCalculationClass);
        this.bind("change:systemId", this.setupCalculationClass, this);

        this.setupCalculationClass();
        this.setupDataProvider();
      },

      setupCalculationClass: function() {
        switch (this.get("systemId")) {

          //Thermoregulation
          case "#2":
            _.extend(this, Thermoregulation);
            break;

          //Intrusion detection
          case "#4":
            _.extend(this, IntrusionDetection);
            break;

          //Audio video
          case "#5+6":
            _.extend(this, AudioVideo);
            break;

          //Automation
          case "#13+20":
            _.extend(this, Automation);
            break;

          //AutomationSimple
          case "#13":
            _.extend(this, AutomationSimple);
            break;

          //EnergyManagement
          case "#21":
            _.extend(this, EnergyManagement);
            break;
        }
      },

      setupDataProvider: function() {
        this.set("dataProvider", new DataProvider());
      }

    });

    // Wizard Views
    // ----------
    Wizard.View = Backbone.View.extend({
      keep: true,
      tagName: "section",
      id: "wizard",

      initialize: function() {
        this.model.set("systemId", this.options.systemId);
        this.model.set("steps", new Steps.Collection(null, {
          systemId: this.model.get("systemId")
        }));
        this.tabs = new Steps.Views.Tabs({
          collection: this.model.get("steps"),
          eventAggregator: Wizard.EventAggregator
        });
        // window.BticinoS4B.eventAggregator.unbind("language:changed",this.render);
        window.BticinoS4B.eventAggregator.bind("language:changed", this.render, this);
        this.loader = new window.BticinoS4B.Instances.Views.LoaderView({model:{quote : "IDS_W4_9010", closeButton : false}});
        this.insertView(".popups", this.loader);
        this.showLoader();
      },

      beforeRender: function() {
        this.$el.append(this.tabs.el);
        this.hideLoader(this.callbackLoader);
      },

      afterRender: function() {
        // this.hideLoader(this.callbackLoader);

        var that=this;
        // setTimeout(function() {
        //   that.tabs.render();
        //   window.customizeFormElements.call();
        // }, 500);
      },
      destroy: function(){
        this.model.destroy();
      },
      callbackLoader: function(){
        this.tabs.render();
      },
      
      showLoader: function() {
        this.loader.render();
        this.loader.show();
      },

      hideLoader: function(callback) {
        var that = this;
        this.loader.model.set('callback', callback);
        this.loader.model.set('callbackScope', this);
        setTimeout(function() {
          that.loader.hide(callback);
        }, 500);
      }

    });

    // Required, return the module for AMD compliance
    return Wizard;

  });